
























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component

export default class ComponentProducaoTipoProcedimento extends Vue {
  @Prop(Object) producao
}
